import { PlanGateModal, usePlanGate } from "components/website/components/planGate";
import { useEffect, useState } from "react";
import { isMobileOnly } from "react-device-detect";
import useReactRouter from "use-react-router";
import { t } from "i18n/index";
import { useMarketingLang } from "i18n/useMarketingLang";
import { getChromeTranslations } from "../marketing/i18n/pages/chrome";
import DownloadAppCTA from "./DownloadAppCTA";

const OutroCTA = () => {
  const { match } = useReactRouter();
  // Default to desktop on first render (matches server output) — flip after mount
  // so SSR + client first paint agree (no hydration mismatch).
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(isMobileOnly);
  }, []);

  const lang = useMarketingLang();
  const translations = getChromeTranslations(lang);

  // 123yb691qz1: this /register anchor never renders on mobile in the first place (the
  // `!isMobile` guard below hands off to `DownloadAppCTA` instead), so `mobile: "store"` is
  // belt-and-braces rather than something this particular CTA can ever exercise.
  const gate = usePlanGate(`footer: ${match.path}`, "store");

  return (
    <section className="stippl-outro">
      <div className="stippl-outro__visual"></div>
      <div className="container__inner">
        <div className="stippl-outro__content">
          <p className="sub-header">{t(translations, "outroCta.subHeader", "sign up now")}</p>
          <h2>{t(translations, "outroCta.heading", "Start your journey")}</h2>
          {!isMobile ? (
            <a
              href="/register"
              className="btn-rounded solid xl"
              onClick={(e) => {
                e.preventDefault();
                gate.requestPlan();
              }}
            >
              {t(translations, "outroCta.signUpFree", "Sign up free")}
            </a>
          ) : null}

          <DownloadAppCTA />
        </div>
      </div>
      <PlanGateModal
        gate={gate}
        title={t(translations, "auth.createAccount", "Create a free account to start planning")}
        loginTitle={t(translations, "auth.loginPlan", "Log in to plan with AI")}
      />
    </section>
  );
};

export default OutroCTA;
